import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.css']
})
export class InfoBoxComponent implements OnInit {

  @Input() pad: boolean = true;
  @Input() link: string = "";
  @Input() icon: string = "";
  @Input('show-buttons') showButtons: boolean = false;

  constructor() { }

  ngOnInit() {
  }


}
